const SET_PROJECTS = 'SET_PROJECTS';

export default SET_PROJECTS;



// WEBPACK FOOTER //
// ./src/containers/common/projects/constants.js